export default __webpack_public_path__ + "static/media/react.dfc4af9e.png";